import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import Downlaods from 'src/pages/user-projects/Downlaods';
// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/user-home/user-home'));
const Sidevideo = lazy(() => import('src/pages/user-projects/SideVideo'));
const UserProjects = lazy(() => import('src/pages/user-projects/user-projects'));
const Projetsdetails = lazy(() => import('src/pages/user-projects/user-projetsdetails'));
const ProjetImages = lazy(() => import('src/pages/projects/ProjectImages'));
const ProjectView = lazy(() => import('src/pages/projects/projectview'));
// ----------------------------------------------------------------------

export const userRoutes = [
    {
        path: 'user-dashboard',
        element: (

            <AuthGuard>
                <RoleBasedGuard roles={['user']} hasContent>
                    <DashboardLayout>
                        <Suspense fallback={<LoadingScreen />}>
                            <Outlet />
                        </Suspense>
                    </DashboardLayout>
                </RoleBasedGuard>
            </AuthGuard>
        ),
        children: [
            { element: <IndexPage />, index: true },
            { path: "/user-dashboard/user-projects", element: <UserProjects /> }, // project  route
            { path: "/user-dashboard/Downloads", element: <Downlaods /> }, // project  route
            { path: "/user-dashboard/Sidevideo", element: <ProjetImages type="genrate" /> }, // project  route
            { path: "/user-dashboard/user-projetsdetails/:projectId", element: <Projetsdetails /> }, // project detail route
            { path: "/user-dashboard/user-projetsdetails/user-projectImages", element: <ProjetImages type="download" /> },
            {
                path: "/user-dashboard/user-projetsdetails/:projectId/user-projectImages/user-projectview/:camraId",
                element: <ProjectView />
            },
        ],
    },
];
